module.exports = __webpack_public_path__ + "img/base_restauration_traiteur.4d0e2289.svg";